import React, { createContext, useCallback, useContext, useState } from 'react'
import { CAlert } from '@coreui/react'

const ToastContext = createContext(null)

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([])

  const toast = useCallback((message, color = 'success') => {
    const id = Date.now()
    setToasts(p => [...p, { id, message, color }])
    setTimeout(() => setToasts(p => p.filter(t => t.id !== id)), 3500)
  }, [])

  return (
    <ToastContext.Provider value={{ toast }}>
      {children}
      <div style={{ position: 'fixed', top: 70, right: 16, zIndex: 9999, width: 320 }}>
        {toasts.map(t => (
          <CAlert
            key={t.id}
            color={t.color}
            className="mb-2 shadow-sm"
            dismissible
            onClose={() => setToasts(p => p.filter(x => x.id !== t.id))}
          >
            {t.message}
          </CAlert>
        ))}
      </div>
    </ToastContext.Provider>
  )
}

export const useToast = () => useContext(ToastContext)
